import { Sparkles } from "lucide-react";

export default function FloatingHearts({ count = 8 }) {
  const sparks = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 6,
    size: 12 + Math.random() * 16,
    color: ["#FF4D8D", "#7B61FF", "#00E5FF"][i % 3],
  }));

  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-0">
      {sparks.map((s) => (
        <Sparkles
          key={s.id}
          className="floating-heart"
          style={{
            left: `${s.left}%`,
            bottom: "-40px",
            width: s.size,
            height: s.size,
            color: s.color,
            fill: s.color,
            animationDelay: `${s.delay}s`,
            opacity: 0.65,
          }}
        />
      ))}
    </div>
  );
}
